import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { VehicleCard } from '../../components/Cards';
import {
  Button, Chip, Empty, Input, Loading,
} from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';

const TYPES = [
  { key: '', label: 'All' },
  { key: 'car', label: '🚗 Cars' },
  { key: 'bike', label: '🏍️ Bikes' },
  { key: 'scooter', label: '🛵 Scooters' },
  { key: 'auto', label: '🛺 Auto' },
  { key: 'commercial', label: '🚚 Commercial' },
];

const SORTS = [
  { key: '', label: 'Newest' },
  { key: 'price_low', label: 'Price ↑' },
  { key: 'price_high', label: 'Price ↓' },
  { key: 'km_low', label: 'Least driven' },
];

const VehiclesPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [type, setType] = useState('');
  const [sort, setSort] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const res = await api.vehicles.list({
        search: search || undefined,
        vehicleType: type || undefined,
        sort: sort || undefined,
        limit: 30,
      });
      setItems(res.data || []);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [search, type, sort]);

  useEffect(() => {
    const timer = setTimeout(load, search ? 350 : 0);
    return () => clearTimeout(timer);
  }, [load, search]);

  return (
    <div>
      <PageHeader
        title="Vehicles"
        subtitle="Buy and sell cars, bikes and more"
        right={(
          <div className="row" style={{ gap: 8 }}>
            <Button title="My listings" variant="light" size="sm" onClick={() => navigate('/my-vehicles')} />
            <Button title="+ Sell" size="sm" onClick={() => navigate('/vehicles/post')} />
          </div>
        )}
      />

      <div className="card sh-sm" style={{ marginBottom: 16 }}>
        <Input
          icon="🔍"
          placeholder="Search brand or model"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: 12 }}
        />
        <div className="row no-bar" style={{ gap: 8, overflowX: 'auto' }}>
          {TYPES.map((t) => (
            <Chip key={t.key || 'all'} label={t.label} active={type === t.key} onClick={() => setType(t.key)} />
          ))}
        </div>
        <div className="row no-bar" style={{ gap: 8, overflowX: 'auto', marginTop: 8 }}>
          {SORTS.map((s) => (
            <Chip key={s.key || 'new'} label={s.label} active={sort === s.key} onClick={() => setSort(s.key)} />
          ))}
        </div>
      </div>

      {loading ? <Loading /> : !items.length ? (
        <Empty
          emoji="🚗"
          title="No vehicles listed yet"
          text="Be the first to list your vehicle for sale on KAAMWALA."
          actionLabel="Sell my vehicle"
          onAction={() => navigate('/vehicles/post')}
        />
      ) : (
        <div className="grid grid-products">
          {items.map((v, i) => (
            <Reveal key={v._id} delay={stagger(i, 40)}>
              <VehicleCard vehicle={v} onClick={() => navigate(`/vehicles/${v._id}`)} />
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default VehiclesPage;
